import PageTabContent from "@/App/Layouts/PageBody/PageTabContent";
import ViewContentBlock from "@/App/Layouts/ViewContentBlock";
import { ViewVariant } from "@/common/ts/layout";
import { AccessoryCheckDto, EntityType } from "@/core/api/generated/v1";

import GeneralHistoryPaginatedList from "../../../GeneralHistory/ListView/GeneralHistoryPaginatedList";

interface Props {
  accessoryCheck: AccessoryCheckDto;
}

export default function GeneralHistoryTabContent({ accessoryCheck }: Props) {
  return (
    <PageTabContent>
      <ViewContentBlock>
        <GeneralHistoryPaginatedList
          defaultValues={{
            subjectEntityType: EntityType.AccessoryCheck,
            subjectEntityId: accessoryCheck.id,
          }}
          displayProps={{
            viewVariant: ViewVariant.Tab,
          }}
        />
      </ViewContentBlock>
    </PageTabContent>
  );
}
